<template>
  <div :style="'display: flex;width: 780px;'">
    <div class="form-column">
      <el-form class="result-form">
        <table cellpadding="0" cellspacing="0">
          <tr>
            <td class="header">{{ $t('FileHistory.fileName') }}</td>
            <td colspan="3">
              <span style="margin-left: 10px;">{{ details.fileName }}</span>
            </td>
          </tr>
          <tr>
            <td class="header">{{ $t('SeaExport.SerialNo') }}</td>
            <td><span style="margin-left: 10px;">{{ details.fileNo }}</span></td>
            <td class="header">{{ $t('SeaExport.BusinessNumber') }}</td>
            <td><span style="margin-left: 10px;">{{ details.jobNo }}</span></td>
          </tr>
          <tr>
            <td class="header">{{ $t('SeaExport.Hbl2') }}</td>
            <td><span style="margin-left: 10px;" /></td>
            <td class="header">{{ $t('SeaExport.Mbl2') }}</td>
            <td><span style="margin-left: 10px;">{{ resultJson.billNo }}</span></td>
          </tr>
          <tr>
            <td class="header">{{ $t('SeaExport.SoNo') }}</td>
            <td><span style="margin-left: 10px;">{{ resultJson.soNo }}</span></td>
            <td class="header">{{ $t('SeaExport.WarehouseNo') }}</td>
            <td><el-input v-model="resultJson.warehouseReceiptNo" no="1" /></td>
          </tr>
          <tr>
            <td rowspan="7" class="header">{{ $t('Message.Shipper') }}</td>
            <td><el-form-item><el-input v-model="job.shipperLine1" no="2" /></el-form-item></td>
            <td class="header">{{ $t('SeaExport.BLForm') }}</td>
            <td>
              <div class="mapperClass">
                <el-form-item><el-input v-model="resultJson.blType" no="3" @change="mapperBlType" /></el-form-item>
                <el-select
                  v-model="job.orderType"
                  no="4"
                >
                  <el-option
                    v-for="(item,index) in blModeList"
                    :key="index"
                    :label="item.name"
                    :value="item.serialNumber"
                  />
                </el-select>
              </div>
            </td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.shipperLine2" no="5" /></el-form-item></td>
            <td class="header">{{ $t('SeaExport.LCL') }}</td>
            <td>
              <div class="mapperClass">
                <el-form-item><el-input v-model="resultJson.fclOrLcl" no="6" @change="mapperLoadType" /></el-form-item>
                <el-select v-model="job.containerLoadType" no="7">
                  <el-option
                    v-for="(item,index) in (containerLoadTypes)"
                    :key="index"
                    :label="isZh?item.chineseName:item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </div>
            </td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.shipperLine3" no="8" /></el-form-item></td>
            <td class="header">{{ $t('SeaExport.ShippingCompany') }}</td>
            <td>
              <div class="mapperClass">
                <el-form-item><el-input v-model="resultJson.carrier" no="9" @change="mapperShipName" /></el-form-item>
                <cargo-company-select
                  no="10"
                  :method-params="{companyLob:'seaExport',seaCmp:true,active:true}"
                  :default-value="job.carrierId||''"
                  style="width: 150px;"
                  @change="p=>{job.carrierId=p.value}"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.shipperLine4" no="11" /></el-form-item></td>
            <td class="header">{{ $t('Payment.vessel') }}</td>
            <td><el-form-item><el-input v-model="resultJson.vessel" no="12" /></el-form-item></td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.shipperLine5" no="13" /></el-form-item></td>
            <td class="header">{{ $t('Payment.voyage') }}</td>
            <td><el-form-item><el-input v-model="resultJson.voyage" no="14" /></el-form-item></td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.shipperLine6" no="15" /></el-form-item></td>
            <td class="header">{{ $t('queryJob.dateOfDeparture') }}</td>
            <td>
              <div class="mapperClass">
                <el-form-item><el-input v-model="resultJson.etd" no="16" @change="mapperEtd" /></el-form-item>
                <el-date-picker
                  no="17"
                  :value="job.etd"
                  type="date"
                  style="width: 150px;"
                  value-format="yyyy-MM-dd"
                  @input="etdChange"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.shipperLine7" no="18" /></el-form-item></td>
            <td class="header">{{ $t('Payment.contactPerson') }}</td>
            <td><el-form-item><el-input v-model="resultJson.email" no="19" /></el-form-item></td>
          </tr>
          <tr>
            <td rowspan="7" class="header">{{ $t('Message.Consignee') }}</td>
            <td><el-form-item><el-input v-model="job.consigneeLine1" no="20" /></el-form-item></td>
            <td class="header">{{ $t('SeaExport.TransportationClause') }}</td>
            <td>
              <div class="mapperClass">
                <el-form-item><el-input v-model="resultJson.serviceTerm" no="21" @change="mapperFreightTerm" /></el-form-item>
                <cargo-advance-select
                  no="22"
                  :select-type="selectTypeNames.basic_data_ShippingTerm"
                  filterable
                  :clearable="false"
                  :default-value="job.freightTerm"
                  style="width: 150px;"
                  @parentCallBack="p=>{job.freightTerm=p.value}"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.consigneeLine2" no="23" /></el-form-item></td>
            <td class="header">{{ $t('SeaExport.FreightTerm') }}</td>
            <td>
              <div class="mapperClass">
                <el-form-item><el-input v-model="resultJson.freightClauseName" no="24" @change="mapperPaymentTerm" /></el-form-item>
                <cargo-advance-select
                  no="25"
                  :select-type="selectTypeNames.basic_data_PaymentTerm"
                  filterable
                  :clearable="false"
                  :default-value="job.paymentTermMBL"
                  style="width: 150px;"
                  @parentCallBack="p=>{job.paymentTermMBL=p.value;}"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.consigneeLine3" no="27" /></el-form-item></td>
            <td class="header" rowspan="2">{{ $t('SeaExport.ContainerSize') }}</td>
            <td rowspan="2">
              <div v-for="(item,index) in job.seaEQ" :key="index">
                <div style="display: flex">
                  <div style="width: 49%">
                    <el-input v-model="item.eqQuantity" :placeholder="$t('CargoMsg.Cargo_ContainerAmount')" no="eqQuantity" style="width: 40px;" />
                    {{ item.showEQ }}
                  </div>
                  <div style="display:flex;">
                    <cargo-advance-select
                      no="eqSize"
                      :select-type="selectTypeNames.local_cache_EQSize"
                      :fields="['code']"
                      filterable
                      :placeholder="' '"
                      :show-copy="false"
                      :default-value="item.eqSize"
                      style="width: 75px;"
                      tag-name="code"
                      @parentCallBack="p=>{changeSizeCallBack(item, p)}"
                    />
                    <cargo-advance-select
                      no="eqType"
                      :select-type="selectTypeNames.basic_data_EQType"
                      :fields="['code']"
                      filterable
                      :placeholder="' '"
                      :show-copy="false"
                      :default-value="item.eqType"
                      style="width: 75px;"
                      tag-name="code"
                      @parentCallBack="p=>{changeTypeCallBack(item, p)}"
                    />
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.consigneeLine4" no="29" /></el-form-item></td>
            <!--            <td class="header">{{ $t('SeaExport.ContainerAmount') }}</td>-->
            <!--            <td><el-form-item><el-input v-model="resultJson.containerNo" no="30" /></el-form-item></td>-->
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.consigneeLine5" no="31" /></el-form-item></td>
            <td colspan="2" />
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.consigneeLine6" no="34" /></el-form-item></td>
            <td colspan="2" />
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.consigneeLine7" no="36" /></el-form-item></td>
            <td colspan="2" />
          </tr>
          <tr>
            <td rowspan="7" class="header">{{ $t('Message.Notify') }}</td>
            <td><el-form-item><el-input v-model="job.notifyLine1" no="37" /></el-form-item></td>
            <td class="header">{{ $t('SeaExport.Quantity') }}</td>
            <td><el-form-item><el-input v-model="resultJson.quantity" no="38" /></el-form-item></td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.notifyLine2" no="39" /></el-form-item></td>
            <td class="header">{{ $t('SeaExport.Package') }}</td>
            <td>
              <div class="mapperClass">
                <el-form-item><el-input v-model="resultJson.packageType" no="40" @change="mapperPacking" /></el-form-item>
                <cargo-packing-select :default-value="job.packing" no="41" style="width: 180px;" @change="p=>{job.packing=p.value}" />
              </div>
            </td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.notifyLine3" no="42" /></el-form-item></td>
            <td class="header">{{ $t('SeaExport.Weight') }}</td>
            <td><el-form-item><el-input v-model="resultJson.grossWeight" no="43" /></el-form-item></td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.notifyLine4" no="44" /></el-form-item></td>
            <td class="header">{{ $t('SeaExport.Cubage') }}</td>
            <td><el-form-item><el-input v-model="resultJson.measurement" no="45" /></el-form-item></td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.notifyLine5" no="46" /></el-form-item></td>
            <td colspan="2" />
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.notifyLine6" no="47" /></el-form-item></td>
            <td colspan="2" />
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.notifyLine7" no="48" /></el-form-item></td>
            <td colspan="2" />
          </tr>
          <tr>
            <td class="header">{{ $t('CargoMsg.Cargo_PlaceOfReceipt') }}</td>
            <td>
              <div class="mapperClass">
                <el-form-item><el-input v-model="resultJson.portOfReceipt" no="49" @change="mapperSeaPort('destinationPortCode', 'portOfReceipt')" /></el-form-item>
                <cargo-advance-select
                  no="50"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  filterable
                  :default-value="job.destinationPortCode"
                  tag-name="englishName"
                  style="width: 180px;"
                  @parentCallBack="p=>{job.destinationPortCode=p.value;}"
                />
              </div>
            </td>
            <td class="header">{{ $t('Payment.portOfLoading') }}</td>
            <td>
              <div class="mapperClass">
                <el-form-item><el-input v-model="resultJson.portOfLoading" no="51" @change="mapperSeaPort('loadingPortCode', 'portOfLoading')" /></el-form-item>
                <cargo-advance-select
                  no="52"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  filterable
                  :default-value="job.loadingPortCode"
                  tag-name="englishName"
                  style="width: 180px;"
                  @parentCallBack="p=>{job.loadingPortCode=p.value;}"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td class="header">{{ $t('queryJob.dischargingPortCode') }}</td>
            <td>
              <div class="mapperClass">
                <el-form-item><el-input v-model="resultJson.portOfDischarge" no="53" @change="mapperSeaPort('dischargingPortCode', 'portOfDischarge')" /></el-form-item>
                <cargo-advance-select
                  no="54"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  filterable
                  :default-value="job.dischargingPortCode"
                  style="width: 180px;"
                  @parentCallBack="p=>{job.dischargingPortCode=p.value}"
                />
              </div>
            </td>
            <td class="header">{{ $t('queryJob.placeOfDelivery') }}</td>
            <td>
              <div class="mapperClass">
                <el-form-item><el-input v-model="resultJson.placeOfDelivery" no="55" @change="mapperSeaPort('destinationPortCode', 'placeOfDelivery')" /></el-form-item>
                <cargo-advance-select
                  no="56"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  filterable
                  :default-value="job.destinationPortCode"
                  style="width: 180px;"
                  @parentCallBack="p=>{job.destinationPortCode=p.value}"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td class="header">{{ $t('SeaExport.Marks') }}</td>
            <td><el-form-item><el-input v-model="resultJson.marks" type="textarea" resize="none" :rows="10" no="57" /></el-form-item></td>
            <td class="header">{{ $t('Pricing.Goods') }}</td>
            <td><el-form-item><el-input v-model="resultJson.goodsDescription" type="textarea" resize="none" :rows="10" no="58" /></el-form-item></td>
          </tr>
          <tr>
            <td colspan="4">
              <cargo-ag-grid
                :show-side-bar="false"
                :grid-options="goods.gridOptions"
                :column-defs="goodsColumnDefs"
                :row-data="goods.rowData"
                style="width:800px;height:200px;"
                @gridReady="params=>{goods.gridApi=params.api}"
              />
            </td>
          </tr>
          <tr>
            <td class="header">{{ $t('Payment.remarks') }}</td>
            <td colspan="3"><el-form-item><el-input v-model="resultJson.remark" type="textarea" resize="none" :rows="5" no="59" /></el-form-item></td>
          </tr>
        </table>
      </el-form>
    </div>

  </div>
</template>

<script>
import { cache, cacheName } from '@/utils/cacheManager'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { CONTAINERLOAD_TYPES } from '@/class/cargo/model/parameters/ContainerLoadType'
import CargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import CargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import ColumnUtils from '@/utils/ColumnUtils'
import { getOcrList } from '@/api/ocrSet'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import StrUtils from '@/utils/StrUtils'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import { deepClone } from '@/utils'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import * as BlModeType from '@/class/cargo/model/parameters/BlModeType'
import DateUtils from '@/utils/dateUtils'
import { User } from '@/class/model/sys/User'
import { Office } from '@/class/model/sys/Office'

export default {
  name: 'ResultFormSiBy',
  components: { CargoRichTextarea, AutoNumberInput, CargoUserSelect, CargoAdvanceSelect, CargoPackingSelect, cargoCompanySelect },
  props: {
    details: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      resultJson: {},
      containerLoadTypes: CONTAINERLOAD_TYPES,
      SystemConstants,
      ColumnUtils,
      selectTypeNames: TYPE_NAMES,
      useCase: 0, // 0 海运出口 1 空运出口
      otherField: {},
      expressList: [],
      mapperTexts: [],
      containerQuantity: [],
      port: new Map(),
      carrier: new Map(),
      blType: new Map(),
      loadType: new Map(),
      shippingTerm: new Map(),
      paymentTerm: new Map(),
      incoTerm: new Map(),
      eq: new Map(),
      customer: new Map(),
      packing: new Map(),
      blModeList: [
        { serialNumber: 1, code: 'ORIGINAL', name: 'ORIGINAL', localName: this.$t('SeaExport.OriginalNormal') },
        { serialNumber: 2, code: 'SURRENDERED', name: 'SURRENDERED', localName: this.$t('SeaExport.TelexRelease') },
        { serialNumber: 3, code: 'SEA WAYBILL', name: 'SEA WAYBILL', localName: this.$t('SeaExport.TelexRelease') }
      ],
      job: {},
      initJob: {
        customerId: 0,
        containerLoadType: '',
        carrierId: 0,
        freightTerm: '',
        paymentTermMBL: '',
        incoTerm: '',
        etd: '',
        seaEQ: [],
        loadingPortCode: '',
        transferPortCode: '',
        dischargingPortCode: '',
        destinationPortCode: '',
        packing: '',
        orderType: '',
        shipperLine1: '',
        shipperLine2: '',
        shipperLine3: '',
        shipperLine4: '',
        shipperLine5: '',
        shipperLine6: '',
        shipperLine7: '',
        consigneeLine1: '',
        consigneeLine2: '',
        consigneeLine3: '',
        consigneeLine4: '',
        consigneeLine5: '',
        consigneeLine6: '',
        consigneeLine7: '',
        notifyLine1: '',
        notifyLine2: '',
        notifyLine3: '',
        notifyLine4: '',
        notifyLine5: '',
        notifyLine6: '',
        notifyLine7: '',
        cargoSource: '',
        arriveDate: '',
        customCutoff: '',
        customerCutoff: '',
        customerShutout: '',
        customerFileCutoff: '',
        csr: 0,
        csrDepartment: 0,
        csrOffice: 0,
        dc: 0,
        dcDepartment: 0,
        dcOffice: 0,
        insideQuantity: 0,
        insidePacking: '',
        chargeWeight: 0,
        userDefinedField1: '',
        userDefinedField2: '',
        userDefinedField3: '',
        userDefinedField4: '',
        cargoChineseName: '',
        mbl: ''
      },
      goods: {
        selectedRow: null,
        gridOptions: {
          singleClickEdit: true,
          rowSelection: 'single',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          onRowClicked: event => { this.goods.selectedRow = event.data }
        },
        rowData: [],
        gridApi: null
      }
    }
  },
  computed: {
    readOnly() {
      return this.details && this.details.status === 3
    },
    showOtherField() {
      return this.expressList && this.expressList.length > 0
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    goodsColumnDefs() {
      return [
        {
          headerName: this.$t('SeaExport.ContainerNo'),
          colId: 'ctnno',
          field: 'ctnno',
          width: 130
        },
        {
          headerName: this.$t('SeaExport.SealNo'),
          colId: 'sealno',
          field: 'sealno',
          width: 130
        },
        {
          headerName: this.$t('SeaExport.Weight'),
          colId: 'weight',
          field: 'weight',
          width: 130
        }, {
          headerName: this.$t('SeaExport.Quantity'),
          colId: 'count',
          field: 'count',
          width: 130
        }, {
          headerName: this.$t('SeaExport.Cubage'),
          colId: 'volume',
          field: 'volume',
          width: 130
        }, {
          headerName: this.$t('SeaExport.ContainerSize'),
          colId: 'ctnType',
          field: 'ctnType',
          width: 130
        }
      ]
    }
  },
  watch: {
    details(val, oldVal) {
      if (val.resultJson !== oldVal.resultJson) {
        this.init()
      }
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    await this.init()
  },
  methods: {
    handleFocus(val) {
      this.$emit('fieldFocus', val)
    },
    async init() {
      this.resultJson = JSON.parse(this.details.resultJson)
      // 将json信息转换成对应的值
      if (!this.resultJson.jobJson) {
        this.resultJson.jobJson = deepClone(this.initJob)
      }
      if (this.resultJson && this.resultJson.billNo) {
        this.resultJson.jobJson.mbl = this.resultJson.billNo
      }
      this.job = this.resultJson.jobJson
      this.goods.rowData = this.resultJson.container || []
      await this.initOcrSet()
      this.convertSft()
      if (this.resultJson.containerNo) {
        this.containerQuantity = this.resultJson.containerNo.split(';')
      }
      this.setSeaEq()
      this.convertMapper()
      this.initOther()
    },
    setSeaEq() {
      try {
        this.job.seaEQ = []
        if (this.resultJson.containerType) {
          const dataArray = this.resultJson.containerType.split(';')
          let i = 0
          for (const data of dataArray) {
            const cData = data.split('\'')
            const eqData = {}
            eqData.eqSizeOrg = cData[0]
            eqData.eqTypeOrg = cData[1]
            eqData.eqQuantity = Number(this.containerQuantity[i] || 1)
            if (cData.length > 1) {
              const eqSize = ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_EQSize, 'code', eqData.eqSizeOrg, 'code')
              const eqType = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_EQType, 'code', eqData.eqTypeOrg, 'code')
              if (eqSize && eqType) {
                eqData.eqSize = eqSize
                eqData.eqType = eqType
              }
            }
            eqData.showEQ = 'X' + eqData.eqSizeOrg + '' + eqData.eqTypeOrg
            this.job.seaEQ.push(eqData)
            i += 1
          }
        }
      } catch (e) {
        console.log('ResultFormSeBy error', e)
      }
    },
    initOther() {
      getSpecificBasicData(basicCacheKeys.basic_data_BlMode).then(data => {
        for (const item of data) {
          if (item.blType === BlModeType.HBL.code) {
            const blMode = this.blModeList.find(p => p.uuid === item.uuid)
            if (!blMode) {
              this.blModeList.push(item)
            }
          }
        }
      })
    },
    convertMapper() {
      this.initMapper()
      // 委托单位
      if (!this.job.customerId || Number(this.job.customerId) <= 0) {
        this.mapperClient()
      }
      // 整箱拼箱
      if (StrUtils.isEmpty(this.job.containerLoadType) && !StrUtils.isEmpty(this.resultJson.fclOrLcl)) {
        this.mapperLoadType()
      }
      // 船公司
      if (!this.job.carrierId || Number(this.job.carrierId) <= 0) {
        this.mapperShipName()
      }
      // 开航日期
      if (StrUtils.isEmpty(this.job.etd) && !StrUtils.isEmpty(this.resultJson.etd)) {
        this.mapperEtd()
      }
      // 运输条款
      if (StrUtils.isEmpty(this.job.freightTerm) && !StrUtils.isEmpty(this.resultJson.serviceTerm)) {
        this.mapperFreightTerm()
      }
      // 运费条款
      if (StrUtils.isEmpty(this.job.incoTerm) && !StrUtils.isEmpty(this.resultJson.freightClauseName)) {
        this.mapperPaymentTerm()
      }
      // 起运港
      if (StrUtils.isEmpty(this.job.loadingPortCode) && !StrUtils.isEmpty(this.resultJson.portOfLoading)) {
        this.mapperSeaPort('loadingPortCode', 'portOfLoading')
      }
      // // 中转港
      // if (StrUtils.isEmpty(this.job.transferPortCode) && !StrUtils.isEmpty(this.resultJson.transitPort)) {
      //   this.mapperSeaPort('transferPortCode', 'transitPort')
      // }
      // 卸货港
      if (StrUtils.isEmpty(this.job.dischargingPortCode) && !StrUtils.isEmpty(this.resultJson.portOfDischarge)) {
        this.mapperSeaPort('dischargingPortCode', 'portOfDischarge')
      }
      // 交货地
      if (StrUtils.isEmpty(this.job.destinationPortCode) && !StrUtils.isEmpty(this.resultJson.placeOfDelivery)) {
        this.mapperSeaPort('destinationPortCode', 'placeOfDelivery')
      }
      // 包装
      if (StrUtils.isEmpty(this.job.packing) && !StrUtils.isEmpty(this.resultJson.packageType)) {
        this.mapperPacking()
      }
      // 提单形式
      if (StrUtils.isEmpty(this.job.orderType) && !StrUtils.isEmpty(this.resultJson.blType)) {
        this.mapperBlType()
      }
    },
    // 转换收发通地址
    convertSft() {
      if (this.job.shipperLine1 || this.job.consigneeLine1 || this.job.notifyLine1) return
      const shipper = this.resultJson.shipper
      const consignee = this.resultJson.consignee
      const notifyParty = this.resultJson.notify
      for (let i = 1; i < 8; i++) {
        this.job[`shipperLine${i}`] = ''
        this.job[`consigneeLine${i}`] = ''
        this.job[`notifyLine${i}`] = ''
        this.splitSft(shipper, 'shipperLine')
        this.splitSft(consignee, 'consigneeLine')
        this.splitSft(notifyParty, 'notifyLine')
      }
    },
    splitSft(oldVal, type) {
      if (oldVal) {
        const oldValArr = oldVal.split('\n')
        const line7Arr = []
        for (let j = 0; j < oldValArr.length; j++) {
          if (j < 7) {
            this.job[type + `${j + 1}`] = oldValArr[j] ? oldValArr[j] : ''
            continue
          }
          line7Arr.push(oldValArr[j])
        }
        if (line7Arr.length > 0) {
          this.job[type + '7'] = line7Arr.join(',')
        }
      }
    },
    // 获取OCR映射
    async initOcrSet() {
      const params = {
        branchId: this.$store.getters.currentOfficeId,
        anyInteger: 0, // 应用场景 0海运出口托书识别
        anyBool: true // 应用场景 判断是否应用总部
      }
      await getOcrList(params).then(res => {
        const ocrSet = res.data
        if (ocrSet) {
          // 文字映射
          this.toMapperText(ocrSet)
          // 额外录单字段
          this.toOtherField(ocrSet)
        }
      })
    },
    // 文字映射
    toMapperText(ocrSet) {
      const mapperList = ocrSet.mapperList || []
      const mapperHqList = ocrSet.mapperHqList || []
      const otherMapper = mapperList.length > 0 ? mapperList[0] : null
      if (otherMapper && otherMapper.ifHq) {
        this.mapperTexts = mapperHqList
      }
      if (!this.mapperTexts || this.mapperTexts.length === 0) {
        this.mapperTexts = mapperList || []
      }
    },
    initMapper() {
      this.port = new Map()
      this.carrier = new Map()
      this.blType = new Map()
      this.loadType = new Map()
      this.shippingTerm = new Map()
      this.paymentTerm = new Map()
      this.incoTerm = new Map()
      this.eq = new Map()
      this.customer = new Map()
      this.packing = new Map()
      const mapperTexts = this.mapperTexts
      if (!mapperTexts || mapperTexts.length <= 0) {
        return
      }
      for (const mapperText of this.mapperTexts) {
        const mapperKey = mapperText.type + '_' + mapperText.useCase + '_' + mapperText.oldText
        const mapperVal = mapperText.newText
        if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_PORT.code) {
          this.port.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_CARRIER.code) {
          this.carrier.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_BL_TYPE.code) {
          this.blType.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_LOAD_TYPE.code) {
          this.loadType.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_SHIPPING_TERM.code) {
          this.shippingTerm.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_PAYMENT_TERM.code) {
          this.paymentTerm.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_INCO_TERM.code) {
          this.incoTerm.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_EQ.code) {
          this.eq.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_CUSTOMER.code) {
          this.customer.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_PACKING.code) {
          this.packing.set(mapperKey, mapperVal)
        }
      }
    },
    // 额外录单字段
    toOtherField(ocrSet) {
      const fieldList = ocrSet.fieldList || []
      const fieldHqList = ocrSet.fieldHqList || []
      const otherField = fieldList.length > 0 ? fieldList[0] : null
      let tempField = null
      if (otherField && otherField.ifHq) {
        tempField = fieldHqList.length > 0 ? fieldHqList[0] : null
      }
      if (!tempField) tempField = otherField
      if (!tempField) return
      const pattern = tempField.useField
      if (!pattern) {
        return
      }
      const expressList = []
      let index = -1
      for (let i = 0; i < pattern.length; ++i) {
        if (pattern[i] === '$' && pattern[i + 1] === '{') {
          index = i
          continue
        }
        if (pattern[i] === '}' && index > -1) {
          const name = pattern.substring(index + 2, i)
          const value = true
          expressList.push({ name, value })
          index = -1
        }
      }
      /* 表达式关联表单数据 */
      for (const item of expressList) {
        this.otherField[item.name] = !!item.value
      }
      this.$logger.log('expressList========', expressList)
      this.expressList = expressList
    },
    // 货物列表更改
    onGoodsCellChange() {

    },
    // 委托单位
    mapperClient() {
      if (!StrUtils.isEmpty(this.resultJson.client)) {
        // 用解析值 匹配 代码
        let customerId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cnShortName', this.resultJson.client, 'cmpIdx')
        if (!customerId) {
          // 用解析值 匹配 英文名
          customerId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'englishName', this.resultJson.client, 'cmpIdx')
          if (!customerId || Number(customerId) <= 0) {
            // 用解析值 匹配 中文名
            customerId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'chineseName', this.resultJson.client, 'cmpIdx')
            if (!customerId || Number(customerId) <= 0) {
              const mapperKey = SystemConstants.OCR_MAPPER_TYPE_CUSTOMER.code + '_' + this.useCase + '_' + this.resultJson.client
              const newMapperVal = this.customer.get(mapperKey)
              if (newMapperVal) {
                // 用映射值 匹配 代码
                customerId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cnShortName', newMapperVal, 'cmpIdx')
                if (!customerId || Number(customerId) <= 0) {
                  // 用映射值 匹配 英文名
                  customerId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'englishName', newMapperVal, 'cmpIdx')
                  if (!customerId || Number(customerId) <= 0) {
                    // 用映射值 匹配 中文名
                    customerId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'chineseName', newMapperVal, 'cmpIdx')
                  }
                }
              }
            }
          }
        }
        this.job.customerId = customerId || 0
      }
    },
    // 船公司
    mapperShipName() {
      if (!StrUtils.isEmpty(this.resultJson.carrier)) {
        // 用解析值 匹配 代码
        let carrierId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cnShortName', this.resultJson.carrier, 'cmpIdx')
        if (!carrierId) {
          // 用解析值 匹配 英文名
          carrierId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'englishName', this.resultJson.carrier, 'cmpIdx')
          if (!carrierId || Number(carrierId) <= 0) {
            // 用解析值 匹配 中文名
            carrierId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'chineseName', this.resultJson.carrier, 'cmpIdx')
            if (!carrierId || Number(carrierId) <= 0) {
              const mapperKey = SystemConstants.OCR_MAPPER_TYPE_CARRIER.code + '_' + this.useCase + '_' + this.resultJson.carrier
              const newMapperVal = this.carrier.get(mapperKey)
              if (newMapperVal) {
                // 用映射值 匹配 代码
                carrierId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cnShortName', newMapperVal, 'cmpIdx')
                if (!carrierId || Number(carrierId) <= 0) {
                  // 用映射值 匹配 英文名
                  carrierId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'englishName', newMapperVal, 'cmpIdx')
                  if (!carrierId || Number(carrierId) <= 0) {
                    // 用映射值 匹配 中文名
                    carrierId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'chineseName', newMapperVal, 'cmpIdx')
                  }
                }
              }
            }
          }
        }
        this.job.carrierId = carrierId || 0
      }
    },
    mapperEtd() {
      if (this.resultJson.etd) {
        let etd = DateUtils.toDateStr(this.resultJson.etd)
        if (!etd && this.resultJson.etd.length > 8) {
          etd = ColumnUtils.dateTimeLabelFunc(this.resultJson.etd)
        }
        this.job.etd = etd || ''
      }
    },
    // 整箱拼箱
    mapperLoadType() {
      if (!StrUtils.isEmpty(this.resultJson.fclOrLcl)) {
        // 用解析值 匹配 代码
        let loadType = ContainerLoadType.getContainerLoadTypeByCode(this.resultJson.fclOrLcl)
        let loadTypeCode = loadType ? loadType.code : ''
        if (!loadTypeCode) {
          // 用解析值 匹配 中英文名
          loadType = ContainerLoadType.getContainerLoadTypeByName(this.resultJson.fclOrLcl)
          loadTypeCode = loadType ? loadType.code : ''
          if (!loadTypeCode) {
            const mapperKey = SystemConstants.OCR_MAPPER_TYPE_LOAD_TYPE.code + '_' + this.useCase + '_' + this.resultJson.fclOrLcl
            const newMapperVal = this.loadType.get(mapperKey)
            if (newMapperVal) {
              // 用映射值 匹配 代码
              loadType = ContainerLoadType.getContainerLoadTypeByCode(newMapperVal)
              loadTypeCode = loadType ? loadType.code : ''
              if (!loadTypeCode) {
                // 用映射值 匹配 中英文名
                loadType = ContainerLoadType.getContainerLoadTypeByName(newMapperVal)
                loadTypeCode = loadType ? loadType.code : ''
              }
            }
          }
        }
        this.job.containerLoadType = loadTypeCode || ''
      }
    },
    // 运输条款
    mapperFreightTerm() {
      if (!StrUtils.isEmpty(this.resultJson.serviceTerm)) {
        // 用解析值 匹配 代码
        let freightTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ShippingTerm, 'code', this.resultJson.serviceTerm, 'code')
        if (!freightTerm) {
          // 用解析值 匹配 英文名
          freightTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ShippingTerm, 'name', this.resultJson.serviceTerm, 'code')
          if (!freightTerm) {
            // 用解析值 匹配 中文名
            freightTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ShippingTerm, 'localName', this.resultJson.serviceTerm, 'code')
            if (!freightTerm) {
              const mapperKey = SystemConstants.OCR_MAPPER_TYPE_SHIPPING_TERM.code + '_' + this.useCase + '_' + this.resultJson.serviceTerm
              const newMapperVal = this.shippingTerm.get(mapperKey)
              if (newMapperVal) {
                // 用映射值 匹配 代码
                freightTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ShippingTerm, 'code', newMapperVal, 'code')
                if (!freightTerm) {
                  // 用映射值 匹配 英文名
                  freightTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ShippingTerm, 'name', newMapperVal, 'code')
                  if (!freightTerm) {
                    // 用映射值 匹配 中文名
                    freightTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ShippingTerm, 'localName', newMapperVal, 'code')
                  }
                }
              }
            }
          }
        }
        this.job.freightTermHBL = freightTerm || ''
        this.job.freightTerm = freightTerm || ''
      }
    },
    // 运费条款
    mapperPaymentTerm() {
      if (!StrUtils.isEmpty(this.resultJson.freightClauseName)) {
        // 用解析值 匹配 代码
        let paymenTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_PaymentTerm, 'code', this.resultJson.freightClauseName, 'code')
        if (!paymenTerm) {
          // 用解析值 匹配 英文名
          paymenTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_PaymentTerm, 'name', this.resultJson.freightClauseName, 'code')
          if (!paymenTerm) {
            // 用解析值 匹配 中文名
            paymenTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_PaymentTerm, 'localName', this.resultJson.freightClauseName, 'code')
            if (!paymenTerm) {
              const mapperKey = SystemConstants.OCR_MAPPER_TYPE_PAYMENT_TERM.code + '_' + this.useCase + '_' + this.resultJson.freightClauseName
              const newMapperVal = this.paymentTerm.get(mapperKey)
              if (newMapperVal) {
                // 用映射值 匹配 代码
                paymenTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_PaymentTerm, 'code', newMapperVal, 'code')
                if (!paymenTerm) {
                  // 用映射值 匹配 英文名
                  paymenTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_PaymentTerm, 'name', newMapperVal, 'code')
                  if (!paymenTerm) {
                    // 用映射值 匹配 中文名
                    paymenTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_PaymentTerm, 'localName', newMapperVal, 'code')
                  }
                }
              }
            }
          }
        }
        this.job.paymentTermHBL = paymenTerm || ''
        this.job.paymentTermMBL = paymenTerm || ''
      }
    },
    // 起运港 中转港 卸货港 交货地
    mapperSeaPort(code = '', jsonCode = '') {
      if (!code) return
      if (!this.resultJson[jsonCode]) return
      // 用解析值 匹配 代码
      let portCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', this.resultJson[jsonCode], 'code')
      if (!portCode) {
        // 用解析值 匹配 英文名
        portCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'englishName', this.resultJson[jsonCode], 'code')
        if (!portCode) {
          // 用解析值 匹配 中文名
          portCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'chineseName', this.resultJson[jsonCode], 'code')
          if (!portCode) {
            const mapperKey = SystemConstants.OCR_MAPPER_TYPE_PORT.code + '_' + this.useCase + '_' + this.resultJson[jsonCode]
            const newMapperVal = this.port.get(mapperKey)
            if (newMapperVal) {
              // 用映射值 匹配 代码
              portCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', newMapperVal, 'code')
              if (!portCode) {
                // 用映射值 匹配 英文名
                portCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'englishName', newMapperVal, 'code')
                if (!portCode) {
                  // 用映射值 匹配 中文名
                  portCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'chineseName', newMapperVal, 'code')
                }
              }
            }
          }
        }
      }
      this.job[code] = portCode || ''
    },
    // 包装
    mapperPacking(packingVal = '') {
      let realPacking = this.resultJson.packageType
      if (packingVal) { // 多单模式时 packingVal 有值
        realPacking = packingVal
      }
      let packingCode = ''
      if (!StrUtils.isEmpty(realPacking)) {
        // 用解析值 匹配 代码
        packingCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Packing, 'code', realPacking, 'code')
        if (!packingCode) {
          // 用解析值 匹配 英文名
          packingCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Packing, 'name', realPacking, 'code')
          if (!packingCode) {
            // 用解析值 匹配 中文名
            packingCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Packing, 'chineseName', realPacking, 'code')
            if (!packingCode) {
              const mapperKey = SystemConstants.OCR_MAPPER_TYPE_PACKING.code + '_' + this.useCase + '_' + realPacking
              const newMapperVal = this.packing.get(mapperKey)
              if (newMapperVal) {
                // 用映射值 匹配 代码
                packingCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Packing, 'code', newMapperVal, 'code')
                if (!packingCode) {
                  // 用映射值 匹配 英文名
                  packingCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Packing, 'name', newMapperVal, 'code')
                  if (!packingCode) {
                    // 用映射值 匹配 中文名
                    packingCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Packing, 'chineseName', newMapperVal, 'code')
                  }
                }
              }
            }
          }
        }
        if (!packingVal) { // 多单模式时 packingVal 有值
          this.job.packing = packingCode || ''
        }
      }
      return packingCode
    },
    // 提单形式 ORIGINAL 正本 1/SURRENDERED 电放 2/SEA WAYBILL 电放 3
    mapperBlType() {
      if (!StrUtils.isEmpty(this.resultJson.blType)) {
        let releaseType = 0
        const orderType = this.resultJson.blType
        if (orderType === 'ORIGINAL') {
          releaseType = 1
        } else if (orderType === 'SURRENDERED') {
          releaseType = 2
        } else if (orderType === 'SEA WAYBILL') {
          releaseType = 3
        } else {
          releaseType = ColumnUtils.getBlModeSerialNumberByName(orderType)
        }
        if (releaseType) {
          const mapperKey = SystemConstants.OCR_MAPPER_TYPE_BL_TYPE.code + '_' + this.useCase + '_' + this.resultJson.blType
          const newMapperVal = this.blType.get(mapperKey)
          if (newMapperVal) {
            // 用映射值 匹配 中英文名
            releaseType = ColumnUtils.getBlModeSerialNumberByName(newMapperVal)
          }
        }
        this.job.orderType = releaseType
        this.job.seaCargoDoc = [{
          docType: 'HBL',
          releaseType: releaseType || 1
        }]
      }
    },
    etdChange(value) {
      this.job.etd = value
    },
    // 保存时获取数据
    getSubmitData() {
      const result = this.resultJson
      result.jobJson = this.job
      return result
    },
    // 客服改变
    async csrChangeHandler(data) {
      const job = this.job
      job.csr = data.value
      job.csrDepartment = 0
      job.csrOffice = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'csr', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.$store.getters.currentOfficeId) {
              const office = await Office.getOfficeById(item.officeId)
              job.csrOffice = office ? office.officeId : 0
              job.csrDepartment = item.departmentId
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'csr')
          if (dep) {
            job.csrDepartment = dep.departmentId
            const office = await Office.getOfficeByUuid(dep.officeUuid)
            job.csrOffice = office ? office.officeId : 0
          }
        }
      }
    },
    changeSizeCallBack(item, p) {
      item.eqSizeOrg = item.eqSize = p.value
      item.showEQ = 'X' + item.eqSizeOrg + '' + item.eqTypeOrg
    },
    changeTypeCallBack(item, p) {
      item.eqTypeOrg = item.eqType = p.value
      item.showEQ = 'X' + item.eqSizeOrg + '' + item.eqTypeOrg
    },
    // 单证改变
    async dcChangeHandler(data) {
      const job = this.job
      job.dc = data.value
      job.dcDepartment = 0
      job.dcOffice = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'doc', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.$store.getters.currentOfficeId) {
              const office = await Office.getOfficeById(item.officeId)
              job.dcOffice = office ? office.officeId : 0
              job.dcDepartment = item.departmentId
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'doc')
          job.dcDepartment = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.dcOffice = office ? office.officeId : 0
        }
      } else {
        job.dc = 0
        job.dcDepartment = 0
        job.dcOffice = 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.result-form{
  padding: 10px;
  table{
    width: 100%;
    tr{
      td {
        border: 1px solid #DCDFE6;
        height: 30px;
        &.header {
          width: 70px;
          text-align: center;
        }
        .el-form-item{
          margin: 0!important;
          input{
            border:none!important;
          }
        }
        .mapperClass {
          display: flex;
          align-items: center;
        }
      }
    }
  }
}
</style>
